export default "/react/oohdeskIcon-56ee7333.svg";